import React from 'react';
import { m } from 'motion/react';
import { Calendar, MessageSquare, UserPlus, UploadCloud, CheckCircle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const Workflow: React.FC = () => {
  const { t } = useLanguage();
  const workT = t.howItWorks;

  const icons = [
    <Calendar className="text-pstax-blue" size={32} />,
    <MessageSquare className="text-pstax-blue" size={32} />,
    <UserPlus className="text-pstax-blue" size={32} />,
    <UploadCloud className="text-pstax-blue" size={32} />,
    <CheckCircle className="text-pstax-blue" size={32} />
  ];

  return (
    <section id="how-we-work" className="py-24 bg-pstax-bg relative overflow-hidden scroll-mt-20">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-display font-bold mb-4">{workT.title}</h2>
          <p className="text-pstax-gray max-w-2xl mx-auto">{workT.subtitle}</p>
        </div>
        
        <div className="flex flex-col lg:flex-row gap-4 max-w-7xl mx-auto relative mb-16 lg:items-start">
          {workT.steps.map((step: any, i: number) => (
            <div key={i} className="flex-1 flex flex-col items-center text-center px-4 group relative">
              {i < workT.steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-[calc(50%_+_40px)] w-[calc(100%_-_80px)] h-0.5 bg-pstax-blue/10" />
              )}
              <div className="w-16 h-16 rounded-2xl bg-white border border-pstax-blue/20 flex items-center justify-center mb-6 shadow-sm group-hover:border-pstax-blue/50 transition-colors relative z-10">
                {icons[i]}
                <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-pstax-navy text-white text-[10px] flex items-center justify-center font-bold">
                  {i + 1}
                </div>
              </div>
              <h3 className="text-lg font-display font-bold mb-3 text-pstax-navy">{step.title}</h3>
              <p 
                className="text-pstax-gray text-sm leading-relaxed"
                dangerouslySetInnerHTML={{ __html: step.desc }}
              />
            </div>
          ))}
        </div>

        <div className="text-center">
          <a 
            href="#fit-check" 
            className="btn-primary py-4 px-12 text-lg font-bold shadow-xl shadow-pstax-blue/20 inline-flex items-center gap-2 mb-4"
            data-cta-location="section"
          >
            {workT.cta}
          </a>
          <p className="text-sm text-pstax-gray">{workT.note}</p>
        </div>
      </div>
    </section>
  );
};
